import { useContext, useMemo } from "react";
import { SPOILER_TYPE } from "./../ricos-content/index.js";
import { PluginsContext } from "./../ricos-context/index.js";
const useSpoilerPlugin = (pluginType) => {
  const plugins = useContext(PluginsContext);
  return useMemo(() => {
    const spoilerPlugin = plugins.asArray().find((plugin) => plugin.getType() === SPOILER_TYPE);
    const isSpoilerPluginAvailable = spoilerPlugin && (!spoilerPlugin.getConfig().supportedPlugins || spoilerPlugin.getConfig().supportedPlugins.includes(pluginType));
    return isSpoilerPluginAvailable;
  }, [plugins]);
};
export {
  useSpoilerPlugin
};
//# sourceMappingURL=use-spoiler-plugin.js.map
